import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Overlay component customisation
 * Returns chatbot background and collapse icon styling
 */
export const useOverlayCustomisation = () => {
  const { getField: getBackgroundField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.BACKGROUND,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.CHATBOT,
  });

  const { getField: getIconField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.COLLAPSE_EXPAND_ICON,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.CHATBOT,
  });

  const backgroundColor = getBackgroundField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const iconColor = getIconField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    backgroundColor,
    iconColor,
  };
};
